import React from 'react';
import BaseIcon, { IIconProps, getIconDimension } from '../../BaseIcon';
import { getColor } from '../../colors';

const WinkIconFilled: React.FC<IIconProps> = ({
  size = 'medium',
  width,
  height,
  color = 'currentColor',
  secondaryColor = 'color1',
  ...props
}) => {
  const iconDimension = getIconDimension(size);

  return (
    <BaseIcon
      viewBox="0 0 24 24"
      width={width || iconDimension}
      height={height || iconDimension}
      fill="none"
      color={getColor(color)}
      {...props}
    >
      <circle cx="12" cy="12" r="10" fill={getColor(secondaryColor)} />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 2.34999C6.67045 2.34999 2.34999 6.67045 2.34999 12C2.34999 17.3295 6.67045 21.65 12 21.65C17.3295 21.65 21.65 17.3295 21.65 12C21.65 6.67045 17.3295 2.34999 12 2.34999ZM0.649994 12C0.649994 5.73156 5.73156 0.649994 12 0.649994C18.2684 0.649994 23.35 5.73156 23.35 12C23.35 18.2684 18.2684 23.35 12 23.35C5.73156 23.35 0.649994 18.2684 0.649994 12Z"
        fill="currentColor"
      />
      <path
        d="M8 10.5C8.82843 10.5 9.5 9.82843 9.5 9C9.5 8.17157 8.82843 7.5 8 7.5C7.17157 7.5 6.5 8.17157 6.5 9C6.5 9.82843 7.17157 10.5 8 10.5Z"
        fill="currentColor"
      />
      <path
        d="M16 10.5C16.8284 10.5 17.5 9.82843 17.5 9C17.5 8.17157 16.8284 7.5 16 7.5C15.1716 7.5 14.5 8.17157 14.5 9C14.5 9.82843 15.1716 10.5 16 10.5Z"
        fill="currentColor"
      />
      <path
        d="M8 15C8 15 9.5 17 12 17C14.5 17 16 15 16 15"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 9L14 7"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </BaseIcon>
  );
};

export default WinkIconFilled;
